export const checkEndDate = (time, startDate) => {
  if (!time || !startDate) return;

  return time.getTime() > startDate.getTime() ? 'text-success' : 'text-error';
};
